import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DataService } from '../data.service';
import { PropertyImageModel } from '../models/propertyImageModel';
import { MailRequest, MailRequestEx, MailResource } from '../models/mailRequest';
import { PropertyphotodetailsComponent } from '../propertyphotodetails/propertyphotodetails.component';

@Component({
  selector: 'app-propertyphotos',
  templateUrl: './propertyphotos.component.html',
  styleUrls: ['./propertyphotos.component.scss']
})
export class PropertyphotosComponent implements OnInit {

  constructor(private router: Router, private data: DataService, private _sanitizer: DomSanitizer) { }

  public propertyPhotos: Array<string> = new Array<string>();

  ngOnInit(): void {
    
    this.data.SelectedProperty.propertyimages.forEach(element => {
      this.GetSecureUrl(element.storagekey);
    });
  }

  onPropertyPhotoClicked(photoid: string): void {
    this.data.SelectedPhoto = photoid;
    this.router.navigate(['propertyphotodetails'], { skipLocationChange: false});
  }

  public GetSecureUrl(key: string): void {
    this.data.request<string>('kiosk/secureurl/img/' + key, null, 'GET').subscribe((v) => {
        this.propertyPhotos.push(v);
    }, (error) => {
      console.log('error : ' + error);
    });
  }

  onEmail() : boolean {
    var req: MailRequestEx = new MailRequestEx();
    
    this.data.SelectedProperty.propertyimages.forEach(element => {
      var res : MailResource = {
        Title : "Property Image",
        URL : element.storagekey,
        ResourceType : "img"
      }
      req.MailResources.push(res);
    });  
    this.data.MailReqEx = req;
    this.router.navigate(['mailprogress']);
    return false;
  }

  onWhatsapp() : void {

  }

}
